import { InputNumber, ModalProps } from 'antd'
import { KeyboardEvent, useEffect, useState, useRef, ReactNode } from 'react'
import OverrideValueModalBase from './OverrideValueModalBase'
import * as Model from './overrideValue'

export type Props = {
  visible: boolean
  label: string
  name: string
  currentValue?: number
  defaultValue: number
  onCancel: () => void
  onSubmit: (value: number) => void
  onReset: () => void
  precision?: number
  increment?: number
  type?: Model.NumericType
  max?: number
  min?: number
  additionalInfo?: ReactNode
} & Pick<ModalProps, 'getContainer'>

export default function OverrideNumericValueModal({
  visible,
  currentValue,
  defaultValue,
  label,
  name,
  onCancel,
  onSubmit,
  onReset,
  precision,
  increment,
  type,
  max,
  min,
  getContainer,
  additionalInfo
}: Props) {
  const [value, setValue] = useState<number | null>(Model.getNumericValue(defaultValue, currentValue, type))
  useEffect(() => {
    setValue(Model.getNumericValue(defaultValue, currentValue, type))
    if (visible && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus()
        inputRef.current.select()
      }, 100)
    }
    /* eslint-disable-next-line */
  }, [visible])

  const inputRef = useRef<any>()

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
    if (e.code === 'Enter') {
      onSubmit(Model.submitNumeric(value, precision, type))
    }
    if (e.code === 'Escape') {
      onCancel()
    }
  }

  const input = <InputNumber
    style={{ width: '100%' }}
    value={value}
    type='number'
    onChange={value => setValue(value)}
    onKeyDown={onKeyDown}
    addonBefore={type === 'cents' ? "$" : undefined}
    addonAfter={type === 'percentage' ? '%' : undefined}
    precision={type === 'cents' ? 2 : precision}
    step={increment}
    max={max && Model.getNumericValue(max, undefined, type)}
    min={min && Model.getNumericValue(min, undefined, type)}
    ref={inputRef}
  />

  return <OverrideValueModalBase
    visible={visible}
    label={label}
    name={name}
    defaultValue={Model.formatDefaultValue(defaultValue, precision, type)}
    input={input}
    onCancel={onCancel}
    onSubmit={() => onSubmit(Model.submitNumeric(value, precision, type))}
    onReset={onReset}
    showReset={Model.shouldShowNumericReset(value, defaultValue, type)}
    getContainer={getContainer}
    additionalInfo={additionalInfo}
  />
}
